import React from 'react';
import { Smartphone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const IOS_URL = 'https://apps.apple.com/us/app/asofom/id6743803145';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.brella.asofom&hl=en-US';

const AppleLogo = ({ className }) => (
  <svg viewBox="0 0 384 512" fill="currentColor" className={className} aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const GooglePlayLogo = ({ className }) => (
  <svg viewBox="0 0 512 512" fill="currentColor" className={className} aria-hidden="true">
    <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
  </svg>
);

const FooterAppDownload = () => {
  const { language } = useLanguage();
  const isES = language === 'es';
  return (
    <div className="mb-10 bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8 flex flex-col md:flex-row items-center justify-between gap-6" data-testid="footer-app-download">
      <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left">
        <div className="w-12 h-12 rounded-2xl bg-[#FF6B35]/15 border border-[#FF6B35]/40 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-6 h-6 text-[#FF6B35]" />
        </div>
        <div>
          <div className="text-white font-bold text-lg">{isES ? 'Descarga la App ASOFOM' : 'Download the ASOFOM App'}</div>
          <p className="text-sm text-gray-400">
            {isES ? 'Networking, agenda en vivo y avisos en tiempo real de la 20° Convención. ' : 'Networking, live agenda and real-time alerts for the 20th Convention. '}
            <a href="/app-asofom" className="text-[#FF6B35] hover:text-[#FFA26B] font-semibold transition-colors" data-testid="footer-app-download-more">
              {isES ? 'Conoce más →' : 'Learn more →'}
            </a>
          </p>
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-3 flex-shrink-0">
        <a href={IOS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-app-store-btn" className="inline-flex items-center gap-2.5 rounded-xl px-4 py-2.5 bg-white/[0.08] text-white border border-white/20 hover:bg-white/[0.15] hover:border-[#FF6B35]/60 transition-all duration-300 hover:-translate-y-0.5">
          <AppleLogo className="w-5 h-5 flex-shrink-0" />
          <span className="text-left leading-tight">
            <span className="block text-[10px] uppercase tracking-wide text-white/60">{isES ? 'Descárgala en el' : 'Download on the'}</span>
            <span className="block text-sm font-bold">App Store</span>
          </span>
        </a>
        <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-google-play-btn" className="inline-flex items-center gap-2.5 rounded-xl px-4 py-2.5 bg-white/[0.08] text-white border border-white/20 hover:bg-white/[0.15] hover:border-[#FF6B35]/60 transition-all duration-300 hover:-translate-y-0.5">
          <GooglePlayLogo className="w-[18px] h-[18px] flex-shrink-0" />
          <span className="text-left leading-tight">
            <span className="block text-[10px] uppercase tracking-wide text-white/60">{isES ? 'Disponible en' : 'Get it on'}</span>
            <span className="block text-sm font-bold">Google Play</span>
          </span>
        </a>
      </div>
    </div>
  );
};

export default FooterAppDownload;
